// eslint-disable-next-line no-unused-vars
const canRequire = typeof __webpack_require__ === 'function';

module.exports =
{
    branding: 'schott', // 'heute', 'logo', 'schott'
    theme: 'dark', // 'dark', 'light'
    // Meta Tags für Facebook, Twitter
    meta: {
        // Seiten Title
        title: 'Ladeboxen',
        // Beschreibung
        description: 'Tolle Ladeboxen in 3D',
        // Bild
        image: 'https://www.robotspaceship.com/typo3conf/ext/kwtemplate/Resources/Public/Images/robotspaceship-logo.svg',
        // URL
        url: 'https://www.robotspaceship.com/',
    },
    tracking: {
        storyName: 'Name der 3D Story',
        storyID: '3D Story-ID',
        // Tracking deaktivieren
        disabled: true,
    },
    babylon: {
        lightIntensity : 1,

        camera: {
            // Position, Ausrichtung und Kamera Bewegung
            // Kamera Position
            position: [.5 * Math.PI, .5 * Math.PI, 10], // alpha, beta, radius
            moveFunction: 'move', // Wie die Kamera bewegt wird: 'move' Kamerafahrt, 'set' Springt zur Position
            target: [0, 0, 0], // Wohin die Kamera blickt
            animationSpeed: 280, // Geschwindigkeit der Kamerabewegung

            // Begrenzungen
            alphaLimits: [null, null],
            betaLimits: [null, null],
            radiusLimits: [5, 100], // minCamRadius, maxCamRadius
            clipping: [1, 10000.0],
            fov: 0.8,
            invertRotation: false, // Kamera Steuerung umkehren für 360° Sphere Ansicht
            stopOnClick: true, // Kamera Animation stoppen, bei klick

            // Automatisches Drehen
            useAutoRotationBehavior: false,
            idleRotationSpeed: 0.05,

            // Steuerung
            panSensibility: 0, // 0 is deactivated
            wheelPrecision: 25.0, // 3.0 ist Standard
        },
    },
    audio: {
        enabled: true,
        // Dauerhafte Hintergrund Musik
        //background: canRequire && require('./assets/audio/News_Loop3.mp3'),
    },
    objects:
    [
        // {
        //     // Name des Objekts zur Ansteuerung
        //     name: "zdfLogo",
        //     // GLB Dateiname im Ordner app/public/3d-models
        //     filename: "ZDF_Logo.glb",
        //     options: {
        //         //// BaseObject
        //         // true: Objekt anzeigen
        //         visible: false,
        //         // Skalierung: Objekt Größe ändern in allen Dimensionen
        //         scaling: [1, 1, -1],
        //         // Skalierung: Objekt Größe ändern (Alle Dimensionen gleich)
        //         //scale: 0.01,
        //         // Position
        //         position: [0, 0, 0],
        //         // Rotation
        //         rotation: [0.5 * Math.PI, 0, 0],
        //         // Rotation Quaternion, siehe https://doc.babylonjs.com/features/position,_rotation,_scaling#rotationquaternion
        //         //rotationQuaternion: [0.707, 0, 0, 0.707],
        //         // Transparenz (0 bis 1)
        //         //visibility: 0.25,
        //         // RGB-Farbe (diffuse) jeweils Werte 0 bis 255
        //         //diffuse: [255, 0, 0],
        //         // Zur Kamera ausrichten
        //         // 1: X-Achse, 2: Y-Achse, 4: Z-Achse, 7: Alle Achsen
        //         // 3: X & Y-Achse, 5: Z & X-Achse, 6: Z & Y-Achse
        //         // https://doc.babylonjs.com/typedoc/classes/babylon.abstractmesh#billboardmode
        //         billboardMode: 0,
        //         // Overlay Color zum hervorheben von Objekten
        //         //overlayColor: [250/255, 125/255, 25/255],
        //         // Rendering Group ID legt Objekte eine ebene nach vorne (Auch beim Hotspot)
        //         //renderingGroupId: 1
        //
        //         //// MeshObject
        //         // Objekt mit Fade ein und ausblenden, wenn visible sich ändert
        //         fade: false,
        //         // Unter-Mesh-Objekte in der Datei
        //         // Name des Meshs wie im 3D Model
        //         ZDF_Logo: {
        //             visible: true,
        //             fade: false,
        //             // Ist das Objekt anklickbar?
        //             // Bei true wird ein Hotspot durch das Objekt nicht anklickbar, wenn verdeckt.
        //             // Darum sollte bei transparenten Objekten ggf. pickable: false gesetzt werden.
        //             pickable: true,
        //             // Texture auf Objekt durchgehend verschieben. Zum Beispiel für Lava oder Wasser.
        //             // Die zwei Werte geben die Verschiebung-Geschwindigkeit pro Achse an.
        //             //animateTexture: [ -0.001, 0 ],
        //
        //             ZDF_Logo_2: {
        //                 visible: true,
        //                 fade: false,
        //             }
        //         },
        //
        //         //// BabylonObject
        //         // animation=true: startet die Animation im Objekt
        //         animation: false,
        //
        //         // Nur initial, nicht per babylonState
        //         // OnClick Trigger
        //         // trigger: function () { }
        //     },
        //     // Callback wenn Objekt geladen und erstellt wurde zum setzen weiterer Einstellungen.
        //     callback: function (zdfLogo) // eslint-disable-line no-unused-vars
        //     {
        //
        //     }
        // },
         {
             name: "syringe",
             filename: "ladestation-edited-compressed.glb",
             options: {
                 visible: true,
                 position: [0, -3.6, 0],
                 scaling: [3.9, 3.9, 3.9],
                 rotation: [0, 0, 0],
             },
         },// WebGL warning: generateMipmap: Tex image TEXTURE_2D level 0 is incurring lazy initialization.
    ]
};
